import React from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import SettingsSidebar from "../../layouts/SettingsSidebar";
import { Form, Field } from "react-final-form";

const required = (value) => (value ? undefined : "Required");

const InvoiceSetting = () => {
  const [loading, setLoading] = React.useState(true);
  const [initialValues, setInitialValues] = React.useState({});
  const csrftoken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
  React.useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const res = await fetch("/accounts/api/settings/invoice/");
        if (res.ok) {
          const data = await res.json();
          setInitialValues(data);
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error("Failed to fetch invoice settings", err);
      }
    };
    fetchSettings();
  }, []);

  const onSubmit = async (values) => {
    const formData = new FormData();
    formData.append("invoice_prefix", values.invoice_prefix);
    formData.append("digital_signature_name", values.digital_signature_name);
    formData.append("invoice_logo", values.invoice_logo);
    formData.append("digital_signature_image", values.digital_signature_image);
    formData.append(
      "invoice_terms_conditions",
      values.invoice_terms_conditions
    );

    try {
      const res = await fetch("/accounts/api/settings/invoice/", {
        method: "PUT",
        body: formData,
        credentials: "include", // Important: includes cookies
        headers: {
          "X-CSRFToken": csrftoken,
        },
      });
      if (res.ok) {
        // alert("Settings updated successfully");
        window.location.reload();
      } else {
        // alert("Failed to update settings");
      }
    } catch (err) {
      console.error("Error updating settings", err);
    }
  };
  // Helper to get preview URL for image fields
  const getImagePreview = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value; // URL from backend
    if (value instanceof File) return URL.createObjectURL(value); // File object
    return "";
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingsSidebar />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="card">
                <div className="card-body w-100">
                  <div className="content-page-header">
                    <h5>Invoice Settings</h5>
                  </div>
                  {!loading && (
                    <Form
                      onSubmit={onSubmit}
                      initialValues={initialValues}
                      render={({
                        handleSubmit,
                        submitting,
                        pristine,
                        values,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-lg-6 col-12">
                              <Field name="invoice_prefix" validate={required}>
                                {({ input, meta }) => (
                                  <div className="input-block mb-3">
                                    <label>Invoice Prefix</label>
                                    <input
                                      {...input}
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Invoice Prefix"
                                    />
                                    {meta.touched && meta.error && (
                                      <span
                                        className="text-danger"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>

                            <div className="col-lg-6 col-12">
                              <Field
                                name="digital_signature_name"
                                validate={required}
                              >
                                {({ input, meta }) => (
                                  <div className="input-block mb-3">
                                    <label>Digital Signature Name</label>
                                    <input
                                      {...input}
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Digital Signature Name"
                                    />
                                    {meta.touched && meta.error && (
                                      <span
                                        className="text-danger"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>

                            <div className="input-block mb-4 col-lg-6 col-12">
                              <label>Invoice Logo</label>
                              <div className="input-block service-upload logo-upload mb-0">
                                <div className="drag-drop">
                                  <h6 className="drop-browse align-center">
                                    <span className="text-info me-1">
                                      Click To Replace
                                    </span>{" "}
                                    or Drag and Drop
                                  </h6>
                                  <p className="text-muted">
                                    PNG, JPG (Max 800*400px)
                                  </p>
                                  <Field
                                    name="invoice_logo"
                                    parse={(value) => value}
                                    validate={(value) => {
                                      if (!value) return "Required";
                                      if (value && value.type) {
                                        const allowedTypes = [
                                          "image/png",
                                          "image/jpeg",
                                        ];
                                        if (
                                          !allowedTypes.includes(value.type)
                                        ) {
                                          return "Only PNG or JPG files are allowed";
                                        }
                                        return new Promise((resolve) => {
                                          const img = new window.Image();
                                          img.onload = function() {
                                            if (
                                              img.width > 800 ||
                                              img.height > 400
                                            ) {
                                              resolve("Max size is 800x400px");
                                            } else {
                                              resolve(undefined);
                                            }
                                          };
                                          img.onerror = function() {
                                            resolve("Invalid image file");
                                          };
                                          const reader = new FileReader();
                                          reader.onload = function(e) {
                                            img.src = e.target.result;
                                          };
                                          reader.readAsDataURL(value);
                                        });
                                      }
                                      return undefined;
                                    }}
                                  >
                                    {({ input, meta }) => (
                                      <>
                                        <input
                                          type="file"
                                          multiple={false}
                                          accept="image/png, image/jpeg"
                                          onChange={(e) =>
                                            input.onChange(e.target.files[0])
                                          }
                                        />
                                        {meta.touched && meta.error && (
                                          <span
                                            className="text-danger"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {meta.error}
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    marginTop: "10px",
                                  }}
                                >
                                  <span className="sites-logo">
                                    <img
                                      src={getImagePreview(
                                        values?.invoice_logo
                                      )}
                                      alt="upload"
                                      width={"100px"}
                                      height={"100px"}
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="input-block mb-4 col-lg-6 col-12">
                              <label>Invoice Sign</label>
                              <div className="input-block service-upload logo-upload mb-0">
                                <div className="drag-drop">
                                  <h6 className="drop-browse align-center">
                                    <span className="text-info me-1">
                                      Click To Replace
                                    </span>{" "}
                                    or Drag and Drop
                                  </h6>
                                  <p className="text-muted">
                                    PNG, JPG (Max 800*400px)
                                  </p>
                                  <Field
                                    name="digital_signature_image"
                                    validate={(value) => {
                                      if (!value) return "Required";
                                      if (value && value.type) {
                                        const allowedTypes = [
                                          "image/png",
                                          "image/jpeg",
                                        ];
                                        if (
                                          !allowedTypes.includes(value.type)
                                        ) {
                                          return "Only PNG or JPG files are allowed";
                                        }
                                        return new Promise((resolve) => {
                                          const img = new window.Image();
                                          img.onload = function() {
                                            if (
                                              img.width > 800 ||
                                              img.height > 400
                                            ) {
                                              resolve("Max size is 800x400px");
                                            } else {
                                              resolve(undefined);
                                            }
                                          };
                                          img.onerror = function() {
                                            resolve("Invalid image file");
                                          };
                                          const reader = new FileReader();
                                          reader.onload = function(e) {
                                            img.src = e.target.result;
                                          };
                                          reader.readAsDataURL(value);
                                        });
                                      }
                                      return undefined;
                                    }}
                                  >
                                    {({ input, meta }) => (
                                      <>
                                        <input
                                          type="file"
                                          multiple={false}
                                          accept="image/png, image/jpeg"
                                          onChange={(e) =>
                                            input.onChange(e.target.files[0])
                                          }
                                        />
                                        {meta.touched && meta.error && (
                                          <span
                                            className="text-danger"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {meta.error}
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <span className="sites-logo">
                                    <img
                                      src={getImagePreview(
                                        values?.digital_signature_image
                                      )}
                                      alt="upload"
                                      width={"100px"}
                                      height={"100px"}
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-12">
                              <Field
                                name="invoice_terms_conditions"
                                validate={required}
                              >
                                {({ input, meta }) => (
                                  <div className="input-block mb-3">
                                    <label>Terms And Conditions</label>
                                    <input
                                      {...input}
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Terms and Conditions"
                                    />
                                    {meta.touched && meta.error && (
                                      <span
                                        className="text-danger"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                            <div className="col-lg-12">
                              <div className="btn-path text-end">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  disabled={submitting || pristine}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceSetting;
